import fetch from "../utils/fetch";

//查询品牌商
export const getList = (params) =>
  fetch(`/brand/company/list`, {
    method: "get",
    params,
  });

export const add = (body) =>
  fetch(`/brand/company`, {
    method: "post",
    body,
  });

export const edit = (body) =>
  fetch(`/brand/company`, {
    method: "put",
    body,
  });

export const getChannelList = (params) => {
  return fetch(`/brand/company/channel/list`, {
    method: "get",
    params,
  });
};

export const getPositionList = (params) => {
  return fetch(`/brand/company/point/list`, {
    method: "get",
    params,
  });
};

export const getRechargeList = (params) => {
  return fetch(`/brand/company/recharge/list`, {
    method: "get",
    params,
  });
};

export const getConsumeList = (params) => {
  return fetch(`/brand/company/consume/list`, {
    method: "get",
    params,
  });
};



export const confirmRecharge = (body) =>
  fetch(`/brand/company/recharge/confirm`, {
    method: "post",
    body,
  });

